"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  // Don't track while developing.
  if (typeof gtag === "function") {
    if (location && typeof window.excludeGAPaths !== "undefined" && window.excludeGAPaths.some(function (rx) {
      return rx.test(location.pathname);
    })) {
      return;
    }

    window.gtag("set",{ "page_path": location ? location.pathname + location.search + location.hash : undefined});
  }
};